// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-ryno-js": () => import("./../../../src/pages/ryno.js" /* webpackChunkName: "component---src-pages-ryno-js" */),
  "component---src-templates-template-1-js": () => import("./../../../src/templates/template1.js" /* webpackChunkName: "component---src-templates-template-1-js" */)
}

